/* eslint-disable */
(function topic($, Drupal) {
  Drupal.behaviors.topic = {
    attach(context) {
      // $('select[name ="field_region_vocab_target_id_1"]').css('display', 'none');
      // $('input[ name="title_1"]').css('display', 'none');
      // $('select[name ="field_region_vocab_target_id"]').on('change', function () {
      //   const regionId = $(this).find(':selected').val();
      //   const regionText = $('[name=field_region_vocab_target_id] option:selected').text();
      //   $('[name=field_region_vocab_target_id_1] option:selected').text(regionText);
      //   $('[name=field_region_vocab_target_id_1]').val(regionId);
      // });
      // $('input[name="title"]').on('change', function () {
      //   $('input[name="title_1"]').val($(this).val());
      // });
     
      // $('#sp_region__select').find("option").css("color", "rgb(0, 70, 127)");
      // $('#sp_type__select').find("option").css("color", "rgb(0, 70, 127)");
      // // $('#sp_region__select').prop('selectedIndex',0);
      
      // $('#seafood-profiles').find("a.species-card").each(function() {
      //   if ($(this).attr('href').indexOf('#seafood') === -1) {
      //     var href = $(this).attr('href');
      //     $(this).attr('href', href + '#seafood')
      //   }
      // });

      // $('#sf-btn-submit').on('click', function() {
      //   var inputVal = document.getElementById("seafood-profile__title").value;
      //   inputVal = inputVal.toLowerCase();
      //   // inputVal = inputVal.replace(" ", "-");
      //   var url = window.location.origin + '/species-directory/sustainable-seafood?oq=' + inputVal + '&field_species_categories_vocab_1=All&field_species_categories_vocab=All&field_region_vocab=All&items_per_page=25';
          
      //   if (url) { // require a URL
      //         window.location = url; // redirect
      //     }
      //     return false;
      // });
      // $('#sp_region__select').on('change', function() {
      //   var url = window.location.origin + '/species-directory/sustainable-seafood?oq=&field_species_categories_vocab_1=All&field_species_categories_vocab=All&field_region_vocab=' + $(this).val() + '&items_per_page=25'
      //   if (url) {

      //         window.location = url;
      //     }
      //     return false;
      // });
      // $('#sp_type__select').on('change', function () {
      //   var url = window.location.origin + '/species-directory/sustainable-seafood?oq=&field_species_categories_vocab_1=' + $(this).val() + '&field_species_categories_vocab=All&field_region_vocab=All&items_per_page=25';
      //   if (url) {

      //         window.location = url;
      //     }
      //     return false;
      // });
      // $('.clear_filters').on('click', function() {
      //   $('#seafood-profile__title').val('');
      //   $('#sp_region__select').prop('selectedIndex',0);
      //   $('#sp_type__select').prop('selectedIndex',0);
      // });

    },
  };
}(jQuery, Drupal));
/*eslint-enable */
